import React from "react";
import { Container, Menu } from "semantic-ui-react";
import { NAVBAR_STYLES } from "../../css/styles";
import AccountMenu from "./AccountMenu";
import logo from "../../assets/icons/logo-white.svg";

export default function Navbar() {
  return (
    <Menu className="navbar-menu" text fixed="top" style={NAVBAR_STYLES.navbar}>
      <Container>
        <Menu.Item
        // as={Link}
        // to={HOME_PAGE_ROUTE}
        // onClick={() => dispatch(setHrMode(HR_ALL_MODE))}
        >
          <div className="hello-radius-logo-container">
            <img
              className="hello-radius-logo"
              src={logo}
              alt="hello radius"
              data-testid="hello-radius-logo-image-testid"
            />
          </div>
        </Menu.Item>
        <Menu.Item style={{ marginLeft: 35 }}>
          <div
            className="main-text white-text"
            style={{
              padding: "10px 15px",
              backgroundColor: "#25a6ca",
              borderRadius: 12,
            }}
          >
            Internal site
          </div>
        </Menu.Item>
        <AccountMenu navbar={NAVBAR_STYLES.navbar} />
      </Container>
    </Menu>
  );
}
